const ProductChips = ({ product, setProduct }) => {
  const products = [
    { id: 'tshirt', label: 'T-Shirt' },
    { id: 'mug', label: 'Mug' },
    { id: 'coffee', label: 'Coffee' },
    { id: 'tumbler', label: 'Tumbler' },
    { id: 'box', label: 'Box' },
  ];

  return (
    <div
      className='
        flex
        items-center

        gap-2
        px-4
        py-2

        border-b
        border-[#E7E2D9]
        bg-white

        overflow-x-auto
        scrollbar-hide

        lg:justify-center
      '
    >
      {products.map((p) => {
        const active = product === p.id;

        return (
          <button
            key={p.id}
            onClick={() => setProduct(p.id)}
            className={`
              flex-shrink-0

              relative
              px-4
              py-1.5

              text-[12px]
              sm:text-[13px]

              font-medium
              rounded-full

              border

              transition-all
              duration-200

              whitespace-nowrap
              select-none

              ${
                active
                  ? `
                    bg-[#C6A75E]
                    text-white
                    border-[#C6A75E]
                    shadow-sm
                  `
                  : `
                    bg-white
                    text-[#1F1F1F]
                    border-[#E7E2D9]
                    hover:bg-[#F3F1EA]
                  `
              }
            `}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
};

export default ProductChips;
